import React from "react";
import styles from "./scss/Button.module.scss";
import cx from "clsx"

const Button = ({ onClick, children, className }) => {
  return (
    <button className={cx(styles.primaryButton, className)} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
